import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="bg-white py-32">
      <div className="max-w-5xl mx-auto px-6 lg:px-10 text-center">
        <p className="text-[#6E6E73] text-sm font-semibold uppercase tracking-widest mb-6">
          Ready to Start
        </p>
        <h2 className="text-6xl lg:text-7xl font-extrabold text-[#0A0A0A] leading-none tracking-tighter mb-8">
          Stop losing jobs
          <br />
          <span className="text-[#6E6E73] font-light">to missed calls.</span>
        </h2>
        <p className="text-[#6E6E73] text-xl font-light leading-relaxed mb-12 max-w-xl mx-auto">
          Get a free automation audit and see exactly where revenue is slipping.
          We map your workflow at no cost—before building anything.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/services"
            className="whitespace-nowrap bg-[#0A0A0A] text-white font-semibold text-base px-10 py-4 rounded-full hover:bg-[#1D1D1F] transition-colors cursor-pointer"
          >
            Get Started
          </Link>
          <a
            href="#how-it-works"
            className="whitespace-nowrap bg-[#F5F5F7] text-[#0A0A0A] font-medium text-base px-10 py-4 rounded-full hover:bg-[#EBEBF0] transition-colors cursor-pointer"
          >
            See How It Works
          </a>
        </div>
      </div>
    </section>
  );
}
